import { render } from "./OnboardingScreen.vue?vue&type=template&id=2d7838c8&scoped=true"
import script from "./OnboardingScreen.vue?vue&type=script&lang=js"
export * from "./OnboardingScreen.vue?vue&type=script&lang=js"

import "./OnboardingScreen.vue?vue&type=style&index=0&id=2d7838c8&lang=scss&scoped=true"
import "./OnboardingScreen.vue?vue&type=style&index=1&id=2d7838c8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7838c8"]])

export default __exports__